// Module
var code = `<span class="deck-copy">{{#contactParts}}{{#mail}}<a class="deck-link" href="{{attrHref}}">{{text}}</a>{{/mail}}{{#web}}<a class="deck-link" href="{{attrHref}}" target="_blank" rel="noopener noreferrer">{{text}}</a>{{/web}}{{#plain}}<span class="deck-contact-text">{{text}}</span>{{/plain}}{{/contactParts}}</span>
`;
// Exports
module.exports = code;